import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const mediaUrl = (url) => url?.startsWith("http") ? url : `${BACKEND_URL}${url || ""}`;

/**
 * Admin auth uses an httpOnly cookie set by the backend on /admin/login.
 * The cookie is unreadable to JavaScript (XSS-safe) and sent automatically via `withCredentials`.
 * No token is persisted in localStorage or sessionStorage.
 */
export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatINR(n) {
  if (n === null || n === undefined || isNaN(n)) return "₹0";
  return "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function discountPct(price, mrp) {
  if (!mrp || mrp <= price) return 0;
  return Math.round(((mrp - price) / mrp) * 100);
}
